import * as React from 'react'
import { Modal } from '@doordash/component-modal'
import { Text, StackChildren } from '@doordash/design-language'
import { CountryCode } from '@doordash/lib-i18n'
import { CheckUS } from './check-us'
import { CheckCA } from './check-ca'
import { COUNTRY_SHORTCODES } from '../../../constants'

import t from './strings'

type Props = {
  onClose: () => void
  country: CountryCode
  locale?: string
  disablePrimaryAction?: boolean
}

const getCheckSvg = (country: CountryCode, locale?: string) => {
  switch (country) {
    case COUNTRY_SHORTCODES.US:
      return <CheckUS locale={locale} />
    case COUNTRY_SHORTCODES.CA:
      return <CheckCA />
    default:
      return <CheckUS locale={locale} />
  }
}

const BankAccountInfoModal = (props: Props) => (
  <Modal
    {...props}
    title={t.title()}
    primaryAction={
      !props.disablePrimaryAction && {
        text: t.button(),
        onClick: props.onClose,
      }
    }
    actionsFillContainer
    size={Modal.Sizes.Small}
    isFullScreenOnMobile={false}
  >
    <StackChildren size={StackChildren.Sizes.Large}>
      <Text styles={Text.Styles.PageDescriptionBody}>{t.description()}</Text>
      {getCheckSvg(props.country, props.locale)}
    </StackChildren>
  </Modal>
)

export default BankAccountInfoModal
